import styled from 'styled-components/macro'
import { theme, ifProp } from 'styled-tools'

const AccordionHeader = styled.div`
  font-weight: bold;
  color: ${props => (props.selected ? theme('primary') : theme('black'))};
  font-size: ${theme('baseFontSize')} * 0.92;
  cursor: pointer;
  border-bottom: 2px solid ${theme('primary')};
  transition: 0.2s ease;
  padding-left: 0.9375rem;
  padding-top: 2.5rem;
  padding-bottom: 1.75rem;
  &:hover {
    color: ${theme('primary')};
  }
`

const Content = styled.div`
  color: ${theme('light')};
  padding-left: 2.375rem;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
`

const AccordionContainer = styled.div`
  cursor: pointer;
  ${ifProp(
    'thin',
    `
    ${AccordionHeader} {
      padding-top: 1rem;
      padding-bottom: 0.75rem;
    }
    ${Content} {
      padding-left: 0.5rem;
    }
  `,
    ''
  )}
`

export { AccordionHeader, Content, AccordionContainer }
